import { Box, Dialog, styled } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { useState } from "react";
import { TransportationControlReportForm } from "./components/TransportationControlReportForm";

import { useQuery } from "@apollo/client";
import { useNavigate, useParams } from "react-router-dom";
import { NavigationContainer } from "@/components/NavigationButton";
import { AddButton } from "@/components/AddButton";
import { TableContainer } from "@/components/Table";

import {
  TransportationTable,
  transportationDetail,
} from "./components/TransportationTable";

const Body = styled(Box)`
  margin-top: 41px;
  margin-bottom: 96px;
`;
export const TransportationControlReport = () => {
  const params = useParams();
  const navigate = useNavigate();
  const [dialogForm, setDialogForm] = useState(false);
  const [selectedId, setSelectedId] = useState(0);

  const { data } = useQuery(transportationDetail, {
    variables: { params: { id: +(params.id || 0) } },
    fetchPolicy: "cache-and-network",
  });
  const selected = data?.report?.transportationControlDetails?.find(
    (detail) => detail.id === selectedId
  );
  const usedPlates =
    data?.report.transportationControlDetails
      ?.map((detail) => detail.plate!)
      .filter(Boolean) ?? [];

  const goHome = () => navigate(`/formulario-reporte/${params.id}/equipos`);
  const goNext = () => navigate(`/formulario-reporte/${params.id}/comentarios`);
  return (
    <Body>
      <TableContainer>
        <TransportationTable
          onEdit={(detail) => {
            setDialogForm(true);
            setSelectedId(detail.id);
          }}
        />
      </TableContainer>
      <AddButton
        variant="contained"
        onClick={() => {
          setDialogForm(true);
          setSelectedId(0);
        }}
      >
        <AddIcon />
        AGREGAR
      </AddButton>
      <NavigationContainer handleNext={goNext} handlePrev={goHome} />
      <Dialog
        open={dialogForm}
        onClose={() => setDialogForm(false)}
        fullWidth
        PaperProps={{ sx: { maxWidth: 400 } }}
      >
        <TransportationControlReportForm
          close={() => setDialogForm(false)}
          defaultValues={{
            id: selected?.id,
            plate: selected?.plate ?? undefined,
            diesel: selected?.diesel ?? undefined,
            lastOdometer: selected?.lastOdometer ?? undefined,
            chargeOdometer: selected?.chargeOdometer ?? undefined,
            driver: selected?.driver ?? undefined,
          }}
          usedPlates={usedPlates}
        />
      </Dialog>
    </Body>
  );
};
